import { gql } from "@apollo/client";

export const getAudiencePlannerQuery = gql`
    query getAudiencePlanner(
        $targetingSpec: Insights_TargetingSpecJson
        $specSource: SpecSource
        $fieldFilter: [String]
    ) {
        getAudiencePlanner(targetingSpec: $targetingSpec, specSource: $specSource, fieldFilter: $fieldFilter) {
            data {
                targetAudience {
                    audienceSizeMaximum
                    audienceSizeMinimum
                }
                referenceAudience {
                    audienceSizeMaximum
                    audienceSizeMinimum
                }
                categoriesMap {
                    fieldName
                    count
                    id
                    name
                    dimensionName
                    targetAudiencePercent
                }
            }
        }
    }
`;

export const getLensesMetadataQuery = gql`
    query getLensMetadata($ids: [String]) {
        getLensMetadata(ids: $ids) {
            id
            imageLink
            internalName
            lensPreviewUrl
            publicName
        }
    }
`;
